const { InspectorControls } = wp.blockEditor;
const { TextControl, PanelBody, SelectControl, ToggleControl } = wp.components;

const Inspector = ({ attributes, setAttributes }) => {
  const { target, plans_type, plans_city_code } = attributes;

  return (
    <InspectorControls>
      <PanelBody title="Atributos do plano" initialOpen={true}>
        <ToggleControl
          label="Abrir modal de formulário"
          checked={target}
          onChange={() => setAttributes({ target: !target })}
        />

        <SelectControl
          label="Tipo"
          value={plans_type}
          options={[
            { label: 'PF', value: 'PF' },
            { label: 'PJ_PME', value: 'PJ_PME' },
          ]}
          onChange={(value) => setAttributes({ plans_type: value })}
        />

        <TextControl
          label="Código Cidade"
          value={plans_city_code}
          onChange={(value) => setAttributes({ plans_city_code: value })}
        />
      </PanelBody>
    </InspectorControls>
  );
};

export default Inspector;
